import {
  Box,
  Button,
  Skeleton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ImagesDetails from "./ImagesDetails";
import Count from "./CountNum";
import { notify } from "../../../../App";
import { useDispatch, useSelector } from "react-redux";
import {
  add,
  remove,
  updateCartPdOnServer,
} from "../../../../Store/Slices/CartSlice/cartSlice";
import AddToCartBtn from "./AddToCartBtn";
import { GradientBorderBox } from "../../../../Components";

export default function Details({ data, varId }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.userSlice);
  const { list } = useSelector((state) => state.cartSlice);
  const [selectedVar, setSelectedVar] = useState();
  const [countNumber, setCountNumber] = useState(0);
  const [cartVars, setCartVars] = useState([]);
  const [decoration, setDecoration] = useState(false);

  const variants = data?.data?.[0]?.variant;

  let fullPrice = 0;
  cartVars?.forEach((e) => {
    fullPrice += +e?.price * +e?.countOfOrder;
  });

  useEffect(() => {
    const variant = data?.data?.[0]?.variant?.filter((e) => e?.code == varId);
    setSelectedVar({ ...variant?.[0] });
  }, [varId, data]);

  const handleCountNumber = (type) => {
    if (!selectedVar) return;

    setCartVars((prev) => {
      const existing = prev.find((e) => e?.code === selectedVar?.code);
      const currentCount = existing ? existing.countOfOrder : countNumber;
      let newCount = currentCount;

      if (type === "plus") {
        if (currentCount < selectedVar?.max_order) newCount = currentCount + 1;
        else {
          notify("به حداکثر سفارش رسیدید", "error");
          return prev;
        }
      } else {
        if (currentCount > 0) newCount = currentCount - 1;
        else {
          notify("خطا");
          return prev;
        }
      }

      setCountNumber(newCount);

      if (existing) {
        return prev.map((e) =>
          e?.code === selectedVar.code ? { ...e, countOfOrder: newCount } : e,
        );
      } else {
        return [...prev, { ...selectedVar, countOfOrder: newCount }];
      }
    });
  };

  const handleSwapVariants = (item) => {
    setSelectedVar({ ...item });
    setDecoration((prev) => !prev);
  };

  const handleAddToCart = async () => {
    if (!cartVars.length) {
      return notify("هیچ محصولی انتخاب نشده", "error");
    }

    const product = data?.data?.[0];
    const product_code = product?.code;

    const payload = cartVars.map((v) => {
      const variant_code = v.variant_code ?? v.code;
      const qty = v.countOfOrder > 0 ? v.countOfOrder : -1;
      return {
        product_code,
        variant_code,
        qty,
        sum: false,
      };
    });

    if (token) {
      cartVars.forEach((v) => {
        const variant_code = v.variant_code ?? v.code;
        const qty = v.countOfOrder > 0 ? v.countOfOrder : -1;
        if (qty <= 0) {
          dispatch(remove({ code: product_code, variant_code }));
        } else {
          dispatch(
            add({
              code: product_code,
              variant_code,
              quantity: qty,
              limit: v.max_order <= v?.qty ? v?.max_order : v?.qty,
              name: product?.name,
              brand_code: product?.brand_code,
              category_code: product?.category_code,
              price: v.price,
              weight: v.weight,
              image: product?.image,
            }),
          );
        }
      });

      try {
        await dispatch(updateCartPdOnServer(payload)).unwrap();
      } catch (err) {
        notify("خطا در بروزرسانی سبد روی سرور", "error");
        console.error("Bulk update failed:", err);
      }
    } else {
      cartVars.forEach((v) => {
        const variant_code = v.variant_code ?? v.code;
        const qty = v.countOfOrder > 0 ? v.countOfOrder : -1;

        if (qty <= 0) {
          dispatch(remove({ code: product_code, variant_code }));
        } else {
          dispatch(
            add({
              code: product_code,
              variant_code,
              quantity: qty,
              limit: v.max_order,
              name: product?.name,
              brand_code: product?.brand_code,
              category_code: product?.category_code,
              price: v.price,
              weight: v.weight,
              image: product?.image,
            }),
          );
        }
      });

      const updatedCart = [...list];
      localStorage.setItem("cart", JSON.stringify(updatedCart));
    }

    notify("سبد خرید بروزرسانی شد", "success");
  };

  const handlePriceTitle = (vr) => {
    if (vr?.price <= 0) return "تماس بگیرید";
    if (vr?.qty <= 0) return "ناموجود";
    return Number(vr?.price)?.toLocaleString() + "  تومان";
  };

  useEffect(() => {
    if (!selectedVar) return;

    const product_code = data?.data?.[0]?.code;
    const variant_code = selectedVar.variant_code ?? selectedVar.code;

    const fromLocalState = cartVars.find((v) => v.code === selectedVar.code);
    if (fromLocalState) {
      setCountNumber(fromLocalState.countOfOrder);
      return;
    }

    const fromRedux = list.find(
      (item) =>
        item.code === product_code && item.variant_code === variant_code,
    );
    if (fromRedux) {
      setCountNumber(fromRedux.quantity ?? 0);
      setCartVars((prev) => {
        if (!prev.find((v) => v.code === selectedVar.code)) {
          return [
            ...prev,
            { ...selectedVar, countOfOrder: fromRedux.quantity ?? 0 },
          ];
        }
        return prev;
      });
      return;
    }

    const localCart = JSON.parse(localStorage.getItem("cart") || "[]");
    const fromLocal = localCart.find(
      (item) =>
        item.code === product_code && item.variant_code === variant_code,
    );
    if (fromLocal) {
      setCountNumber(fromLocal.quantity ?? 0);
      setCartVars((prev) => {
        if (!prev.find((v) => v.code === selectedVar.code)) {
          return [
            ...prev,
            { ...selectedVar, countOfOrder: fromLocal.quantity ?? 0 },
          ];
        }
        return prev;
      });
      return;
    }

    setCountNumber(0);
  }, [selectedVar, cartVars, list, data]);

  if (!data?.data?.[0]) {
    return (
      <Stack
        direction={{ lg: "row-reverse", xs: "column-reverse" }}
        sx={{
          justifyContent: "center",
          gap: { xs: "24px", md: "2rem" },
          my: "2rem",
        }}
      >
        <Stack sx={{ width: { xs: "100%", lg: "60%" }, gap: "2rem" }}>
          <Skeleton
            variant="rounded"
            height={50}
            sx={{ bgcolor: "rgba(255,255,255,0.03)" }}
          />
          <Skeleton
            variant="rounded"
            height={80}
            sx={{ bgcolor: "rgba(255,255,255,0.03)" }}
          />
          <Skeleton
            variant="rounded"
            height={250}
            sx={{ bgcolor: "rgba(255,255,255,0.03)" }}
          />
        </Stack>
        <Stack sx={{ width: { xs: "100%", lg: "40%" } }}>
          <Skeleton
            variant="rounded"
            height={400}
            sx={{ borderRadius: "2rem", bgcolor: "rgba(255,255,255,0.03)" }}
          />
        </Stack>
      </Stack>
    );
  }

  const colorBtn = variants?.map((item) => {
    const isSelected = selectedVar?.code === item?.code;

    return (
      <Button
        key={item?.code}
        onClick={() => handleSwapVariants(item)}
        sx={{
          p: "4px",
          borderRadius: "50%",
          minWidth: "0",
          border: isSelected
            ? `2px solid ${theme.palette.primary.main}`
            : "2px solid transparent",
          bgcolor: isSelected ? "rgba(255,255,255,0.05)" : "transparent",
          boxShadow: isSelected
            ? `0 0 10px ${theme.palette.primary.lowOpacity}`
            : "none",
          transition: "all .3s cubic-bezier(.2,.9,.3,1)",
          "&:hover": {
            transform: "scale(1.1)",
            bgcolor: "rgba(255,255,255,0.05)",
          },
        }}
      >
        <Box
          sx={{
            bgcolor: item?.color_code || "red",
            height: "26px",
            width: "26px",
            borderRadius: "50%",
            border: "1px solid rgba(255,255,255,0.2)",
          }}
        />
      </Button>
    );
  });

  const prVariants = Object.keys(selectedVar?.code ? selectedVar : {})
    ?.filter(
      (e) =>
        !["title", "code", "max_order", "price", "qty", "color_code"]?.includes(
          e,
        ),
    )
    ?.map((e, index) => {
      return (
        <Stack
          key={index}
          direction={"row"}
          sx={{
            justifyContent: "space-between",
            py: "0.8rem",
            px: "1.2rem",
            borderRadius: "12px",
            backgroundColor: "rgba(255, 255, 255, 0.02)",
            border: "1px solid rgba(255, 255, 255, 0.03)",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.04)",
              borderColor: "rgba(255, 255, 255, 0.06)",
            },
          }}
        >
          <Typography
            sx={{ color: theme.palette.text.secondary, fontSize: "0.9rem" }}
          >
            {e === "color_name" ? "رنگ" : e}
          </Typography>
          <Typography
            sx={{
              color: theme.palette.text.primary,
              fontWeight: 500,
              fontSize: "0.9rem",
            }}
          >
            {selectedVar[e]}
          </Typography>
        </Stack>
      );
    });

  return (
    <Box
      sx={{
        position: "relative",
        py: 2,
        overflow: "hidden",
        bgcolor: "transparent",
      }}
    >
      <Stack
        direction={{ lg: "row-reverse", xs: "column-reverse" }}
        sx={{
          position: "relative",
          zIndex: 1,
          justifyContent: "center",
          gap: { xs: "24px", md: "2.5rem" },
          my: "1rem",
        }}
      >
        <Stack
          sx={{
            width: { xs: "100%", lg: "60%" },
            direction: "rtl",
            justifyContent: "space-between",
            gap: "2rem",
            p: { xs: 2, md: 3.5 },
            backgroundColor: "rgba(255, 255, 255, 0.02)",
            backdropFilter: "blur(24px)",
            WebkitBackdropFilter: "blur(24px)",
            borderRadius: "32px",
            border: "1px solid rgba(255, 255, 255, 0.05)",
            boxShadow:
              "0 15px 40px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255, 255, 255, 0.03)",
          }}
        >
          <Stack>
            <Typography
              component={"h1"}
              variant="h5"
              sx={{
                fontWeight: 800,
                mb: "0.8rem",
                color: theme.palette.text.primary,
                letterSpacing: "-0.5px",
                fontSize: { xs: "1.2rem", md: "1.4rem" },
              }}
            >
              {data?.data?.[0]?.name || "بدون نام"}
            </Typography>

            <Typography
              component={"h2"}
              variant="body1"
              sx={{
                fontWeight: 400,
                lineHeight: 1.7,
                fontSize: "0.9rem",
                color: theme.palette.text.secondary,
              }}
            >
              {data?.data?.[0]?.desc || "توضیحاتی برای این محصول ثبت نشده است."}
            </Typography>
          </Stack>

          <Stack>
            <Typography
              sx={{ fontSize: "0.95rem", fontWeight: "bold", mb: 1.5 }}
            >
              انتخاب رنگ
            </Typography>
            <Stack direction={"row"} sx={{ gap: "0.8rem", flexWrap: "wrap" }}>
              {colorBtn}
            </Stack>
          </Stack>

          <Stack>
            <Typography
              sx={{ fontSize: "0.95rem", fontWeight: "bold", mb: 1.5 }}
            >
              مشخصات محصول
            </Typography>
            <Stack direction={"column"} sx={{ gap: "0.6rem", width: "100%" }}>
              <Typography
                sx={{
                  color: theme.palette.primary.main,
                  fontWeight: "600",
                  fontSize: "0.95rem",
                  mb: 0.5,
                }}
              >
                {selectedVar?.title}
              </Typography>
              {prVariants}
            </Stack>

            <Typography
              sx={{
                mt: "1.5rem",
                textAlign: "center",
                fontSize: "1.1rem",
                color: theme.palette.primary.main,
                fontWeight: "700",
                p: "0.8rem 1.5rem",
                borderRadius: "12px",
                backgroundColor: "rgba(220, 184, 104, 0.04)",
                border: `1px solid ${theme.palette.primary.lowOpacity}`,
              }}
            >
              {handlePriceTitle(selectedVar)}
            </Typography>
          </Stack>

          <Count
            count={countNumber}
            maxOrder={selectedVar?.max_order}
            handleCountNumber={handleCountNumber}
            qty={selectedVar?.qty}
            call={selectedVar?.price <= 0}
          />

          <AddToCartBtn
            fullPrice={fullPrice}
            handleAddToCart={handleAddToCart}
            disabled={selectedVar?.qty <= 0}
            call={selectedVar?.price <= 0}
          />
          <GradientBorderBox
            inside
            bg={false}
            bgGrad="linear-gradient(
          135deg,
          rgb(73, 56, 4) -30%,
          #313131 50%,
           #313131 130%
        )"
          />
        </Stack>

        <Stack sx={{ width: { xs: "100%", lg: "40%" }, zIndex: 10 }}>
          <ImagesDetails data={data} images={data?.data?.[0]?.image} />
        </Stack>
      </Stack>
    </Box>
  );
}
